<template>
  <v-container>
    <p class="primary--text text-center display-1">{{$t('Networks.Network-Info')}}</p>
    <v-row>
      <v-col cols="12" sm="12">
        <v-text-field
          v-model="choosenNetwork.networkId"
          :readonly="readonly"
          :label="$t('Networks.id')"
          required
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="12">
        <v-text-field v-model="name" :readonly="readonly" :label="$t('Networks.name')" required></v-text-field>
      </v-col>
      <v-col cols="12" sm="12">
        <v-textarea :readonly="readonly" v-model="description" auto-grow rows="1">
          <template v-slot:label>
            <div>{{$t('Networks.description')}}</div>
          </template>
        </v-textarea>
      </v-col>
    </v-row>
    <editbuttons
      @back="$emit('back')"
      :admin="admin"
      @user="$emit('user')"
      @delete="deleteNetwork"
      @edit="$emit('edit')"
    ></editbuttons>

    <p v-if="admin" class="primary--text text-center display-1">{{$t('Networks.Network-Connector')}}</p>
    <v-row v-if="admin" justify="space-around" align="center">
      <v-col cols="12" sm="6">
        <v-row align="center">
          <v-col class="text-right">
            <v-jsoneditor
              style="z-index: 1;"
              v-model="testJson"
              :plus="false"
              :options="{ mode: 'code', enableTransform: false }"
              :height="'250px'"
            ></v-jsoneditor>
          </v-col>
          <v-col class="text-left">
            <p>TestJson :</p>
            <vue-json-pretty :data="testJson"></vue-json-pretty>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <codeInput v-if="codeReady && admin" :code="code" @newCode="newCode"></codeInput>
    <v-row v-if="admin" >
      <v-col class="text-center">
        <v-btn class="ma-2" tile outlined color="primary" @click="deleteConnector">
          <v-icon left>mdi-delete</v-icon>
          {{$t('DeviceTypes.delete')}}
        </v-btn>
      </v-col>
      <v-col class="text-center">
        <v-btn class="ma-2" tile outlined color="primary" @click="saveConnector">
          <v-icon left>mdi-arrow-left</v-icon>
          {{$t('DeviceTypes.save')}}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import EditButtonsComponent from "./EditButtons";

import CodeInputComponent from "../DeviceTypes/CodeInput";
import VJsoneditor from "v-jsoneditor/src/index";
import VueJsonPretty from "vue-json-pretty";
import axios from "axios";
import tokenStore from "../../store/TokenStore";

export default {
  components: {
    VJsoneditor,
    VueJsonPretty,
    codeInput: CodeInputComponent,
    editbuttons: EditButtonsComponent,
  },
  data() {
    return {
      readonly: true,
      testJson: {},
      code: "",
      codeReady: false,
    };
  },
  computed: {
    readyToSave: function () {
      if (
        !(
          Object.keys(this.testJson).length === 0 &&
          this.testJson.constructor === Object
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    name: function () {
      return this.choosenNetwork.name;
    },
    description: function () {
      return this.choosenNetwork.description;
    },
    networkId: function () {
      return this.choosenNetwork.networkId;
    },
    scopes: function () {
      return this.choosenNetwork.scopes;
    },
    admin: function () {
      let index = this.scopes.findIndex((scope) => {
        return scope == "admin" || scope == "creator";
      });
      return index >= 0;
    },
  },
  props: {
    choosenNetwork: Object,
  },
  methods: {
    newCode(value) {
      this.code = value;
    },
    deleteNetwork: function () {
      axios
        .delete(
          process.env.VUE_APP_API_ADDR + "/api/network/" + this.networkId,
          {
            headers: { Authorization: tokenStore.getToken() },
          }
        )
        .then((res) => {
          if (res.data.success) {
            this.$emit("saved", this.$t("Networks.Alert.success-remove"));
          }
        })
        .catch((err) => {
          this.$emit("error", err.response.data.errorMessage);
        });
    },
    saveConnector: function () {
      if (this.readyToSave) {
        axios
          .post(
            process.env.VUE_APP_API_ADDR +
              "/api/network/" +
              this.networkId +
              "/connector",
            {
              connector: this.code,
              testJson: this.testJson,
            },
            {
              headers: { Authorization: tokenStore.getToken() },
            }
          )
          .then(() => {
            this.$emit("saved", "Network connector successfully updated !");
          })
          .catch((err) => {
            this.$emit(
              "error",
              "Function can't be correctly interpreted :\n\r" +
                err.response.data.errorMessage
            );
            window.scrollTo(0, 0);
          });
      } else {
        this.$emit("error", "Complete correctly the form !");
        window.scrollTo(0, 0);
      }
    },
    deleteConnector() {
      axios
        .delete(
          process.env.VUE_APP_API_ADDR +
            "/api/network/" +
            this.networkId +
            "/connector",
          {
            headers: { Authorization: tokenStore.getToken() },
          }
        )
        .then(() => {
          this.$emit("saved", "Network connector successfully removed !");
        })
        .catch((err) => {
          this.$emit(
            "error",
            "Function can't be correctly interpreted :\n\r" +
              err.response.data.errorMessage
          );
          window.scrollTo(0, 0);
        });
    },
    reload() {
      if (this.admin) {
        axios
          .get(
            process.env.VUE_APP_API_ADDR +
              "/api/network/" +
              this.networkId +
              "/connector",
            {
              headers: { Authorization: tokenStore.getToken() },
            }
          )
          .then((res) => {
            this.codeReady = false;
            if (res.data.success) {
              this.code = res.data.network.connector;
              setTimeout(() => {
                this.codeReady = true;
                window.scrollTo(0, 0);
              }, 1);
            }
          })
          .catch((err) => {
            this.$emit("error", err.response.data.errorMessage);
            window.scrollTo(0, 0);
          });
      }
    },
  },
  beforeMount() {
    this.reload();
  },
};
</script>